import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { colorGuide } from "../../theme/colors";
import { TextTransformValue } from "./Banner.types";

export const BannerContainer = styled.div<{
  variant: string;
  hasCTA: boolean;
  hasArrow: boolean;
  bgColor?: string;
  textColor?: string;
  fontFamily?: string;
  fontWeight?: number;
  lineHeight?: string | number;
  letterSpacing?: string | number;
  textTransform?: TextTransformValue;
  fontSize?: string | number;
  centered?: boolean;
}>`
  display: flex;
  border-radius: 8px;
  width: 100%;
  background: ${({ bgColor }) =>
    bgColor || colorGuide.lightComponents.banner.backgroundColor};

  ${({
    variant,
    hasCTA,
    hasArrow,
    bgColor,
    textColor,
    fontFamily,
    fontWeight,
    lineHeight,
    letterSpacing,
    centered,
    fontSize = "10px",
  }) => {
    switch (variant) {
      case "big":
        return css`
          padding: ${hasCTA || centered ? "8px 16px" : "16px 16px"};
          justify-content: ${hasCTA ? "flex-start" : "center"};
          align-items: ${hasCTA ? "flex-start" : "center"};
          flex-direction: ${hasCTA ? "column" : "row"};
          flex-shrink: 0;
        `;

      case "mini":
        return css`
          padding: ${hasArrow || centered ? "4px 16px" : "8px 16px"};
          flex-direction: column;
          align-items: flex-start;
          gap: ${hasArrow ? "0" : "10px"};
          background: ${bgColor};
          color: ${textColor || colorGuide.lightComponents.banner.textColor};
          font-family: ${fontFamily || "Lexend, sans-serif"};
          font-weight: ${fontWeight || 500};
          line-height: ${lineHeight || "13px"};
          letter-spacing: ${letterSpacing || "2px"};
          font-size: ${fontSize || "10px"};
        `;
      default:
        return css`
          padding: 8px 16px;
          flex-direction: column;
          align-items: flex-start;
          gap: 10px;
          background: ${bgColor ||
          colorGuide.lightComponents.banner.backgroundColor};
          color: ${textColor || colorGuide.lightComponents.banner.textColor};
          font-family: ${fontFamily || "Lexend, sans-serif"};
          font-weight: ${fontWeight || 500};
          line-height: ${lineHeight || "13px"};
          letter-spacing: ${letterSpacing || "2px"};
          font-size: ${fontSize || "10px"};
        `;
    }
  }}
`;

export const BannerImage = styled.img<{
  hasCTA: boolean;
  height?: string;
  width?: string;
}>`
  width: ${({ hasCTA, width }) => width || (hasCTA ? "56.518px" : "41.481px")};
  height: ${({ hasCTA, height }) => height || (hasCTA ? "47.687px" : "35px")};
  flex-shrink: 0;
`;

export const BannerContent = styled.div<{ hasCTA: boolean }>`
  display: flex;
  align-items: ${({ hasCTA }) => (hasCTA ? "flex-start" : "center")};
  gap: 8px;
  ${({ hasCTA }) => !hasCTA && "flex-shrink: 0;"}
  flex: 1 0 0;
  align-self: stretch;
`;

export const BannerDataContainer = styled.div<{ centered?: boolean }>`
  display: flex;
  flex: 1;
  min-width: 0;
  gap: ${({ centered }) => (centered ? "4px" : "8px")};
  flex-direction: ${({ centered }) => (centered ? "column" : "row")};
  align-items: center;
  justify-content: flex-start;
`;
export const CTAContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  flex: 1 0 0;
`;
export const BannerTextWrapper = styled.div<{
  centered?: boolean;
  hasGap?: boolean;
}>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${({ hasGap }) => (hasGap ? "4px" : "0")};
  flex: 1 0 0;

  /* Make both Typography components take equal width */
  & > * {
    width: 100%;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
export const StyledImageContainer = styled.div<{
  hasCTA?: boolean;
  width?: string;
  height?: string;
}>`
  display: flex;
  width: ${({ hasCTA, width }) => width || (hasCTA ? "60px" : "48px")};
  height: ${({ hasCTA, height }) => height || (hasCTA ? "60px" : "48px")};
  padding: ${({ hasCTA }) =>
    hasCTA ? "6px 1.482px 6.313px 2px" : "6px 3.519px 7px 3px"};
  justify-content: center;
  align-items: center;
  ${({ hasCTA }) => hasCTA && "flex-shrink: 0; aspect-ratio: 1/1;"}
`;

export const ArrowIcon = styled.i`
  font-size: 8px;
`;
